/** True when tenant has feedback_audit_mode_enabled (from login features map).
 * Unlocks thumbs up/down + filter chips on both Actuals and Alert History
 * feedback; when off, only the flag/concern icon shows. */
export function isFeedbackAuditModeEnabled(user) {
  if (!user || !user.tenant)
    return false
  const features = user.features && user.features[user.tenant]
  return !!(features && features.feedback_audit_mode_enabled)
}
